<template>
  <div class="mall-box">
    <div class="box">
      <p class="title">{{ $t("mall.title") }}</p>
      <!-- <div class="tab-box">
        <div :class="{ sel: currTab === '所有' }" @click="tabChange('所有')">
          所有
        </div>
        <div
          :class="{ sel: currTab === '进行中' }"
          @click="tabChange('进行中')"
        >
          进行中
        </div>
        <div
          :class="{ sel: currTab === '未开始' }"
          @click="tabChange('未开始')"
        >
          未开始
        </div>
        <div
          :class="{ sel: currTab === '已结束' }"
          @click="tabChange('已结束')"
        >
          已结束
        </div>
      </div>
      <div class="btn-box">
        <div :class="{ sel: currType === '全部' }" @click="typeChange('全部')">
          全部
        </div>
        <div :class="{ sel: currType === '商品' }" @click="typeChange('商品')">
          商品
        </div>
      </div> -->
      <div class="mall-list-box" v-loading="loading">
        <template v-for="value in mallList">
          <MallItem :itemData="value" />
        </template>
        <MallNoData v-if="mallList.length <= 0" />
      </div>
      <el-pagination
        class="pagination-box"
        background
        layout="prev, pager, next"
        :total="malltotal"
        :page-size="pageData.rows"
        :current-page="pageData.page"
        @current-change="pageChange"
      />
    </div>

    <VFooter />
    <QuestionPopup />
  </div>
</template>

<script>
import { mapState } from "vuex";
import MallItem from "./components/MallItem";
import MallNoData from "./components/MallNoData";
import VFooter from "@/components/footer/VFooter";
import QuestionPopup from "@/components/QuestionPopup/index";
export default {
  components: {
    VFooter,
    MallItem,
    MallNoData,
    QuestionPopup,
  },
  computed: {
    ...mapState(["user", "errorCode"]),
  },
  data() {
    return {
      currTab: "所有",
      currType: "全部",
      malltotal: 0,
      pageData: {
        page: 1,
        rows: 10,
        // cateCode: "RWA|DIMD|TOP100|GCT",
		cateCode: "goods",
		queryDeep: 1
      },
      loading: false,
      mallList: [
        // {
        //   id: 2,
        //   url: "",
        //   status: 3,
        //   img: require("@/assets/img/images/coin-rwa.png"),
        //   title: "RWA COIN",
        //   type: "BNB Smart Chain",
        //   info: this.$t("mall.detail.coinInfo2"),
        //   assetType: this.$t("common.service"),
        //   assetPrice: "0.1200 USD",
        //   issuanceTotal: "200,000,000 RWA",
        //   delivery: this.$t("common.global"),
        //   payPrice: "120 USD",
        // },
        // {
        //   id: 3,
        //   url: "https://dimd.io/#/index",
        //   status: 3,
        //   img: require("@/assets/img/images/coin-dimd.png"),
        //   title: "DIMD Token",
        //   type: "BNB Smart Chain",
        //   info: this.$t("mall.detail.coinInfo3"),
        //   assetType: this.$t("common.goods"),
        //   assetPrice: "0.1500 USD",
        //   issuanceTotal: "1,000,000,000 DIMD",
        //   delivery: this.$t("common.global"),
        //   payPrice: "150 USD",
        // },
        // {
        //   id: 1,
        //   url: "",
        //   status: 3,
        //   img: require("@/assets/img/images/coin-top100.png"),
        //   title: "TOP100 Utility Token",
        //   type: "BNB Smart Chain",
        //   info: this.$t("mall.detail.coinInfo1"),
        //   assetType: this.$t("common.service"),
        //   assetPrice: "0.0700 USD",
        //   issuanceTotal: "500,000,000 TOP100",
        //   delivery: this.$t("common.global"),
        //   payPrice: "140 USD",
        // },
        // {
        //   id: 4,
        //   url: "https://m.rwahk.vip/",
        //   status: 4,
        //   img: require("@/assets/img/images/coin-gct.png"),
        //   title: "Genius Coffee Token",
        //   type: "Ethereum",
        //   info: "ZX Healthcare Group Limited",
        //   assetType: this.$t("common.goods"),
        //   assetPrice: "0.5 HKD",
        //   issuanceTotal: "100,000,000 GCT",
        //   delivery: this.$t("common.global"),
        //   payPrice: "N/A",
        // },
      ],
    };
  },
  created() {
    this.getDataInfo();
  },
  methods: {
    getDataInfo() {
      const _this = this;
      this.loading = true;
      this.$axios.post("/cms/getList", this.pageData).then((res) => {
        if (res.data.code === this.errorCode.ok) {
          if (res.data.data.rows && res.data.data.rows.length > 0) {
            this.mallList = res.data.data.rows.map((item) => ({
              ...item,
              summary: JSON.parse(item.summary),
            }));
          }
          this.malltotal = res.data.data.total;
        }
        this.loading = false;
      });
    },
    pageChange(pageNo) {
      this.pageData.page = pageNo;
      this.getDataInfo();
    },
    tabChange(val) {
      this.currTab = val;
    },
    typeChange(val) {
      this.currType = val;
    },
  },
};
</script>

<style lang="less" scoped>
.mall-box {
  position: relative;
  background: #f5f6f7;
  .box {
    padding: 120px 260px;
    .pagination-box {
      text-align: center;
      margin-top: 60px;
      /deep/ .btn-prev,
      /deep/ .btn-next,
      /deep/ .number {
        width: 44px;
        height: 44px;
        line-height: 44px;
        background: #ffffff;
        box-shadow: 0px 3px 10px 1px rgba(180, 180, 180, 0.06);
        border-radius: 6px 6px 6px 6px;
      }
      /deep/ .active {
        background-color: #4063ff !important;
      }
    }
    .title {
      text-align: center;
      font-family: PingFang SC, PingFang SC;
      font-weight: 800;
      font-size: 36px;
      color: #333333;
    }
    .tab-box {
      gap: 80px;
      display: flex;
      padding: 20px 0;
      justify-content: center;
      border-bottom: 2px solid #e0e0e0;
      div {
        padding: 0 20px;
        cursor: pointer;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 20px;
        color: #666666;
      }
      .sel {
        font-weight: 800;
        color: #4063ff;
        position: relative;
      }
      .sel::before {
        content: "";
        position: absolute;
        display: block;
        left: 0;
        width: 100%;
        bottom: -22px;
        border-bottom: 2px solid #4063ff;
      }
    }
    .btn-box {
      gap: 20px;
      display: flex;
      div {
        width: 104px;
        height: 40px;
        cursor: pointer;
        margin-top: 40px;
        font-weight: 400;
        font-size: 16px;
        color: #999999;
        line-height: 40px;
        text-align: center;
        border: 1px solid #e2e3e3;
        border-radius: 4px 4px 4px 4px;
        font-family: PingFang SC, PingFang SC;
      }
      .sel {
        color: #ffffff;
        background: #4063ff;
      }
    }
    .mall-list-box {
      gap: 30px;
      // column-gap: 30px;
      display: flex;
      flex-wrap: wrap;
      margin-top: 28px;
    }
  }
}
</style>
